import { createSlice } from '@reduxjs/toolkit';

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    pendingRequests: 0,
    authInitialized: false,
  },
  reducers: {
    requestStarted: (state) => {
      state.pendingRequests++;
    },
    requestCompleted: (state) => {
      state.pendingRequests--;
    },
    authInitialized: (state) => {
      state.authInitialized = true;
    },
  },
});

// Action creators are generated for each case reducer function
export const { requestStarted, requestCompleted, authInitialized } =
  appSlice.actions;

export default appSlice.reducer;
